<script>
import apiUsers from '@/api/api-users.js'

export default {
    name: 'LoginComponent',

    props: {
        userLanguage: {
            type: String,
            default: 'cz'
        },
        languageStrings: {
            type: Object,
            default: null
        },
        resetLink: {
            type: String,
            default: ''
        }
    },

    emits: ['set-authorized-user'],

    data() {
        return {
            logginError: false,
            passwordResetState: 0,
            passwordResetEmail: '',
            passwordResetPassword: '',
            passwordResetError: false,
            passwordResetLink: this.resetLink,
            passwordResetErrorEmailMissing: false,

            // email: 'MPC',
            // password: 'test'
            email: '',
            password: ''
        }
    },
    
    methods: {
        async loginUser() {
            let result = await apiUsers.login(this.email, this.password)
            if (result.code === 1) {
                this.logginError = true
            }
            else if (result.code === 0) {
                this.$emit("set-authorized-user", result.data.userId)
            }
        },
        setPasswordResetState(state) {
            this.passwordResetState = state
        },
        async sendResetLink() {
            if (this.passwordResetEmail.length > 0) {
                let result = await apiUsers.resetPassword({ id: 0, userName: '', email: this.passwordResetEmail, language: { id: 0, name: this.userLanguage } })
                if (result.code === 0) {
                    this.passwordResetError = false
                }
                else {
                    this.passwordResetError = true
                    if (result.code === 1)
                        this.passwordResetErrorEmailMissing = true
                }
                this.passwordResetState = 2
            }
        },
        async resetPassword() {
            if (this.passwordResetPassword.length > 0) {
                let result = await apiUsers.resetPassword({ id: 0, userName: '', userPassword: this.passwordResetPassword, resetLink: this.passwordResetLink, language: { id: 0, name: this.userLanguage } })
                if (result.code === 0) {
                    this.passwordResetError = false
                }
                else {
                    this.passwordResetError = true
                    if (result.code === 1)
                        this.passwordResetErrorEmailMissing = true
                }
                this.passwordResetLink = ''
                this.passwordResetState = 3
            }
        }
    }
}
</script>


<template>
    <div class="rows fullsize">
        <div v-if="passwordResetState === 0 && passwordResetLink.length === 0" class="rows justify-center align-center gap-10 max-width" style="flex: 1;">
            <div class="login-logo">
                <img src="@/assets/images/kleentek_logo.png" height="30" />
            </div>

            <input type="email" v-model="email" :placeholder="languageStrings != null && languageStrings.ui != null && languageStrings.ui.login001 != null ? languageStrings.ui.login001 : 'Uživatelské jméno'" @keyup.enter="loginUser()" />
            <div class="rows">
                <input type="password" v-model="password" :placeholder="languageStrings != null && languageStrings.ui != null && languageStrings.ui.login002 != null ? languageStrings.ui.login002 : 'Heslo'" @keyup.enter="loginUser()" />
                <div class="clickable" style="font-size: x-small; text-align: right;" @click="setPasswordResetState(1)">{{ languageStrings != null && languageStrings.ui != null && languageStrings.ui.login004 != null ? languageStrings.ui.login004 : 'Zapomenuté heslo' }}</div>
            </div>
            <button @click="loginUser()">{{ languageStrings != null && languageStrings.ui != null && languageStrings.ui.login003 != null ? languageStrings.ui.login003 : 'Přihlásit' }}</button>

            <div v-if="logginError" class="color-red">{{ languageStrings != null && languageStrings.ui != null && languageStrings.ui.login013 != null ? languageStrings.ui.login013 : 'Chybné uživatelské jméno nebo heslo.' }}</div>
            <div v-else>&nbsp;</div>
        </div>

        <div v-if="passwordResetState === 1" class="rows justify-center align-center gap-10 max-width" style="flex: 1;">
            <div class="login-logo">
                <img src="@/assets/images/kleentek_logo.png" height="30" />
            </div>
            <div>
                <input type="email" v-model="passwordResetEmail" style="width: 300px;" :placeholder="languageStrings != null && languageStrings.ui != null && languageStrings.ui.login006 != null ? languageStrings.ui.login006 : 'Zadejte e-mail, kterým se přihlašujete'" @keyup.enter="sendResetLink()" />
                <div class="clickable" style="font-size: x-small; text-align: right;" @click="setPasswordResetState(0)">{{ languageStrings != null && languageStrings.ui != null && languageStrings.ui.login005 != null ? languageStrings.ui.login005 : 'Zpět na přihlášení' }}</div>
            </div>
            <button @click="sendResetLink()">{{ languageStrings != null && languageStrings.ui != null && languageStrings.ui.login007 != null ? languageStrings.ui.login007 : 'Obnovit heslo' }}</button>
        </div>

        <div v-if="passwordResetState === 2" class="rows justify-center align-center gap-10 max-width" style="flex: 1;">
            <div class="login-logo">
                <img src="@/assets/images/kleentek_logo.png" height="30" />
            </div>
            <div>
                <h3 v-if="!passwordResetError">{{ languageStrings != null && languageStrings.ui != null && languageStrings.ui.login008 != null ? languageStrings.ui.login008 : 'Na zadaný e-mail byl odeslán odkaz pro reset hesla. Odkaz je platný následujících 30 minut.' }}</h3>
                <h3 v-if="passwordResetError && !passwordResetErrorEmailMissing">{{ languageStrings != null && languageStrings.ui != null && languageStrings.ui.login009 != null ? languageStrings.ui.login009 : 'Během odesílání e-mailu s odkazem pro reset hesla nastala chyba.' }}</h3>
                <h3 v-if="passwordResetError && passwordResetErrorEmailMissing">{{ languageStrings != null && languageStrings.ui != null && languageStrings.ui.login014 != null ? languageStrings.ui.login014 : 'E-mail nebyl nalezen. Kontaktujte našeho specialistu Tomáše Turana na telefonu/e-mailu v pracovní dny v době od 8 do 16 hod, který Vám rád ochotně pomůže.' }}</h3>
                <div class="clickable" style="font-size: x-small; text-align: right;" @click="setPasswordResetState(0)">{{ languageStrings != null && languageStrings.ui != null && languageStrings.ui.login005 != null ? languageStrings.ui.login005 : 'Zpět na přihlášení' }}</div>
            </div>
        </div>

        <div v-if="passwordResetLink.length !== 0" class="rows justify-center align-center gap-10 max-width" style="flex: 1;">
            <div class="login-logo">
                <img src="@/assets/images/kleentek_logo.png" height="30" />
            </div>
            <div>
                <input type="password" v-model="passwordResetPassword" style="width: 300px;" :placeholder="languageStrings != null && languageStrings.ui != null && languageStrings.ui.login010 != null ? languageStrings.ui.login010 : 'Zadejte nové heslo'" @keyup.enter="resetPassword()" />
                <div class="clickable" style="font-size: x-small; text-align: right;" @click="setPasswordResetState(0)">{{ languageStrings != null && languageStrings.ui != null && languageStrings.ui.login005 != null ? languageStrings.ui.login005 : 'Zpět na přihlášení' }}</div>
            </div>
            <button @click="resetPassword()">{{ languageStrings != null && languageStrings.ui != null && languageStrings.ui.login007 != null ? languageStrings.ui.login007 : 'Obnovit heslo' }}</button>
        </div>

        <div v-if="passwordResetState === 3" class="rows justify-center align-center gap-10 max-width" style="flex: 1;">
            <div class="login-logo">
                <img src="@/assets/images/kleentek_logo.png" height="30" />
            </div>
            <div>
                <h3 v-if="!passwordResetError">{{ languageStrings != null && languageStrings.ui != null && languageStrings.ui.login011 != null ? languageStrings.ui.login011 : 'Heslo bylo úspěšně resetováno.' }}</h3>
                <h3 v-if="passwordResetError">{{ languageStrings != null && languageStrings.ui != null && languageStrings.ui.login012 != null ? languageStrings.ui.login012 : 'Během resetu hesla nastala chyba.' }}</h3>
                <div class="clickable" style="font-size: x-small; text-align: right;" @click="setPasswordResetState(0)">{{ languageStrings != null && languageStrings.ui != null && languageStrings.ui.login005 != null ? languageStrings.ui.login005 : 'Zpět na přihlášení' }}</div>
            </div>
        </div>

        <div class="footer justify-center align-center gap-30">
            <span><a href="docs/KLEENLAB - GDPR 25.1.pdf" target="_blank">GDPR</a></span>
            <span><a href="docs/KLEENLAB - Cookies 25.1.pdf" target="_blank">Cookies</a></span>
            <span>© 2025 KLEENTEK, spol. s r.o.</span>
        </div>
    </div>
</template>